import styled from 'styled-components';

export const SecondaryButton = styled.button`
  &:hover {
    color: ${props => props.theme.secondary};
  }
`;



// WEBPACK FOOTER //
// ./src/views/Links/components/SecondaryButton.tsx